import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchSubChannelList = createAsyncThunk("fetchSubChannelList", async ({ filters, page, limit }) => {
	const params = new URLSearchParams({
		page,
		limit,
		keyword: filters?.keyword || "",
	});

	const response = await axiosHttp.get(`channel/${filters.channel_id}/sub_channels?${params}`);
	return response.data.data;
});

const SubChannelListSlice = createSlice({
	name: "SubChannelListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchSubChannelList.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchSubChannelList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.tableData.currentPage;
			state.total = action.payload.tableData.total;
		});
		builder.addCase(fetchSubChannelList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default SubChannelListSlice.reducer;
